export default __webpack_public_path__ + "static/media/Conecta.d9fb4ff6.png";